import { Animation, Vector } from "excalibur";
import { derived } from "../../resources";
import { LevelOne } from "../../scenes/level-one/level-one";
import { range } from "../../util";
import { Tower } from "./tower";

export class Seal extends Tower {
    static getSpec() {
        return {
            name: "Seal",
            icon: derived.sealIcon,
            cost: 100,
            description: "Shoots a bullet that does damage equal to the dice roll.",
            factory: (level: LevelOne, pos: Vector) => new Seal(level, pos.x, pos.y)
        }
    }

    getSpec() {
        return Seal.getSpec();
    }

    constructor(level: LevelOne, x: number, y: number) {
        super(level, x, y, 300);
    }

    onInitialize() {
        super.onInitialize();

        const animation = Animation.fromSpriteSheet(
            derived.sealSpritesheet,
            range(0, 6),
            68 * 2,
        );

        this.graphics.use(
            animation
        );
    }    

    shoot(results: number[]) {
        const preferred = this.getPreferredEnemy();

        if (preferred != null) {
            this.shootEnemy(preferred, results.reduce((a, b) => a + b, 0))
        }
    }
}